import { GroupVisit, GroupVisitControllerApi } from "@/services";
import {
  getConfigObject,
  getXtenantId,
  useMutationWithLoading,
} from "@/utils/utils";

type Params = {
  groupVisit: GroupVisit;
};

export const useCreateGroupVisit = () =>
  useMutationWithLoading(async ({ groupVisit }: Params) =>
    new GroupVisitControllerApi(getConfigObject()).createGroupVisit(
      groupVisit,
      getXtenantId()
    )
  );
